import type { TopbarButtonBaseProps } from './base/TopbarButton';

import { useTranslation } from 'react-i18next';

import { CloseIcon } from '../../../images/shapes';

import TopbarButton from './base/TopbarButton';

interface TopbarCancelButtonProps extends TopbarButtonBaseProps {
  /**
   * Link to parent page
   */
  link?: string;
  /**
   * If form is dirty
   */
  isDirty?: boolean;
}

const TopbarCancelButton = ({
  link = '',
  isDirty = false,
  ...props
}: TopbarCancelButtonProps) => {
  const { t } = useTranslation();

  return (
    <TopbarButton
      link={link}
      buttonColor="blueBordered"
      label={isDirty ? t('Global.Cancel') : t('Global.Close')}
      iconImage={<CloseIcon className="w-3 min-w-3" />}
      testIdSuffix="cancel"
      {...props}
    />
  );
};

export default TopbarCancelButton;
